const GST_RATE = 0.05;

/** Format a number as USD currency string, e.g. "$1,234.56". */
export function fmt(amount: number): string {
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
  }).format(amount);
}

/** Calculate 5% GST on a subtotal. */
export function calculateGST(subtotal: number): number {
  return subtotal * GST_RATE;
}

/** Return subtotal + GST. */
export function calculateTotalWithGST(subtotal: number): number {
  return subtotal * (1 + GST_RATE);
}
